import { render, staticRenderFns } from "./Stickers.vue?vue&type=template&id=f480e432&scoped=true&"
import script from "./Stickers.vue?vue&type=script&lang=js&"
export * from "./Stickers.vue?vue&type=script&lang=js&"
import style0 from "./Stickers.vue?vue&type=style&index=0&id=f480e432&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f480e432",
  null
  
)

export default component.exports